
import React from "react";
import ChannelManagementDashboard from "@/components/Revenue/ChannelManagementDashboard";

const ChannelManagement = () => {
  return <ChannelManagementDashboard />;
};

export default ChannelManagement;
